export const BULK_REPORT_ENABLED_ORGS = ['jwllogic', 'gotham'];

export const isBulkReportsEnabledOrg = (orgId) => BULK_REPORT_ENABLED_ORGS.includes(orgId);
